import { getMaterialAssets } from '@/i18n/assets';
import { getLocaleStore } from '@/i18n/index';

/** 复制位移距离 */
/** 复制位移距离 */
export const COPY_DISTANCE = 30;

/** 最小字号 */
export const MIN_FONT_SIZE = 6;

/** 最大字号 */
export const MAX_FONT_SIZE = 8000; // 即画布的最大宽度

/** 图片缩放最小边数值限制 */
export const MIN_IMG_SIZE = 20;

/** 最大的画布个数 */
export const MAX_STAGES = 80;

/** 缩放最小边数值限制 */
export const LAYER_MIN_SIZE = 20;

/** 最大的画布个数提示 */
export const MAX_STAGES_TIP = () => {
    const { $t } = getLocaleStore();
    return $t((v, { r }) => r(v.stageManager.maxStageLimit, [MAX_STAGES]));
};

/** 蒙版图片默认图片 */
export const MASK_DEFAULT_IMG = () => {
    return {
        url: getMaterialAssets().imageLayer.maskURL,
        width: 548,
        height: 493,
    };
};

/** 图片图层画布id前缀 */
export const IMAGE_LAYER_CANVAS_ID_PREFIX = 'layer-canvas-';

/** 消除笔画笔大小 */
export const DEFAULT_PEN_SIZE = 25;

// 底层文字素材放大倍数
// 底层绘画2倍图，一定程度减小图片放大失真
export const TEXTMATERIALIMGRATIO = 2;

/**  */
export const KEYBOARD_OPERATE_CLASSNAME = 'keyboard-operate';
